import ReportByReferralComponent from '../../utils/ReportByReferralComponent/ReportByReferralComponent';
import resolveMetricsConfig from '../../helpers/reportMetrics';
import typeOf from '../../helpers/typeOf';
import config from '../../config';

const reportFormatter = ReportByReferralComponent.formatter;
const reportUtils = ReportByReferralComponent.utils;
const numericFormats = new Set(['number', 'percent', 'currency']);

const getMetricsFromParameters = (parameters = {}) => {
    const binarySource = parameters.binaryMetrics || parameters.metricsBinary;
    return resolveMetricsConfig(parameters, {}, binarySource, reportUtils).keys;
};

const getCellClass = (key, parameters = {}) => {
    const params = key === 'GroupBy'
        ? {
            metricKey: key,
            key: parameters.group_by
        }
        : key;

    const format = reportFormatter.getParams(params)?.format;
    return numericFormats.has(format) ? 'number' : 'text';
};

export const getMetric = (key, value, parameters, isTotals = false) => {
    let params = key;
    if (key === 'GroupBy') {
        params = {
            metricKey: key,
            key: parameters.group_by,
            isTotals
        };
    }

    return reportFormatter.format(value, params, parameters);
};

export const getTr = (data, parameters, isTotals) => {
    let rowClass = '';
    let dataCurrentParentId = '';
    let dataParentId = '';
    if (true === data['ReferrerRow']) {
        rowClass = 'bg-success referrer-row';
        dataCurrentParentId = data['GroupBy'];
    } else if (false === data['ReferrerRow'] && !isTotals) {
        rowClass = 'hidden';
        dataParentId = data['GroupBy'];
    }

    let str = `<tr class="${rowClass}" data-parent-id="${dataParentId}" data-current-parent-id="${dataCurrentParentId}">`;

    const currentMetrics = getMetricsFromParameters(parameters);

    (currentMetrics || []).map((key) => {
        let value = getMetric(key, data[key], parameters, isTotals);

        if (typeOf.isArray(value)) {
            value = `${value[0]}${config.XBT}`;
        }

        if (false === data['ReferrerRow'] && 'GroupBy' === key && !isTotals) {
            value = '';
        }

        let additionalPrefix = '';
        let additionalSuffix = '';
        if (true === data['ReferrerRow'] && 'GroupBy' === key) {
            additionalPrefix = '<span class="detail-icon glyphicon glyphicon-plus-sign" aria-hidden="true"></span> ';
            additionalSuffix = ':';
        }

        str += `<td class="${getCellClass(key, parameters)}">${additionalPrefix}${value}${additionalSuffix}</td>`;
    });

    str += '</tr>';

    return str;
};
